import HtmlDiv from "../HtmlDiv";

type Props = {
  text: string;
};

export default function Description(props: Props) {
  return <HtmlDiv className="description" {...props} />;
}
